export default "__VITE_ASSET__5c9d2de7__"